import {ApolloLink} from '@apollo/client';

import type {InternalOperation} from 'src/internal/revamp/apollo/types';

export default function createOperationTypeSplitLink(
  mutationsLink: ApolloLink,
  queryLink: ApolloLink,
): ApolloLink {
  return ApolloLink.split(
    (operation: InternalOperation) =>
      operation.getContext().graphQlOperation?.type === 'MUTATION',
    mutationsLink,
    queryLink,
  );
}
